export default "__VITE_ASSET__$Asp8zHg__";